<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages" >
                    <section v-for="transport in listeTransport" :key="transport.id">
                        <div class="Fiche" v-if="transport.acf.type == 'Ligne de bus'">
                            <div class="Infos Contact">
                                <p class="paragraphe" v-html="transport.acf.description"></p>
                            </div>
                            <div class="contenu-droit-page">
                                <iframe :src="transport.acf.lien" height="100%" width="100%"></iframe>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
            <section class="Section-pages">
                <section v-for="transport in listeTransport" :key="transport.id">
                    <div class="Fiche" v-if="transport.acf.type == 'Arrêt de bus'">
                        <div class="Infos Contact">
                            <p class="paragraphe" v-html="transport.acf.description"></p>
                        </div>
                        <div class="arret-bus">
                            <div class="contenu-droit-page">
                                <iframe :src="transport.acf.lien" height="100%" width="100%"></iframe>
                            </div>
                            <div class="contenu-droit-page">
                                <img :src="transport.acf.image" height="100%" width="100%">
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'Transport',
    data () {
        return{
            listeTransport:{
                id: 0,
                acf:{
                    type: null,
                    titre: null,
                    descritption: null,
                    image: null,
                    lien: null,
                }
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
        axios.get(param.hostacf+'transport')
        .then(response =>{
        this.listeTransport = response.data;
            console.log('listeTransport', this.listeTransport)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            console.log(this.listePages)
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Transports en commun'){
                    console.log(this.listePages[i])
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Transport.vue